import type { VinCheckData } from "core/typings";

export class VinCheck {
  quantity: number;
  insight: boolean;
  used: number;

  constructor(data?: VinCheckData) {
    if (data) {
      this.quantity = data.quantity;
      this.insight = data.insight;
      this.used = data.used;
    } else {
      this.quantity = 0;
      this.insight = false;
      this.used = 0;
    }
  }
}
